/* eslint-disable camelcase */
import React, { Component } from 'react';
import Loader from 'lib/loader'

export default class MealPlan extends Component {
  constructor(props) {
    super(props);
    const dataProps = props.location && props.location.state ? props.location.state : {}
    if(dataProps.params) {
      dataProps.params.default_serving_size = 2
    }
    this.state = {
      // PEOPLE_COOKING_FOR: 2,
      params: dataProps.params || {default_serving_size: 2},
      DIET_TYPE: [],
      errorMessage: {},
      // otherDiet: false,
      loadData: false,
      url: dataProps.url,
      trackAnalytics: dataProps.trackAnalytics || {}
    };
    console.log(props)
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props){
    const dataProps = props.location && props.location.state ? props.location.state : {}
    this.setState({ url: dataProps.url, params: dataProps.params || {default_serving_size: 2}, trackAnalytics: dataProps.trackAnalytics || {} })
  }

  componentDidMount() {
    this.loadData();
  }

  onClickNext() {
    const { default_serving_size, meal_prep_day, recipes_with_meat } = this.state.params;
    const { params, errorMessage, url, trackAnalytics } = this.state
    console.log(params)
    // const errorMessage = this.state.errorMessage;
    this.setState({ loadData: true})
    if (default_serving_size !== undefined && meal_prep_day !== undefined && recipes_with_meat !== undefined && meal_prep_day !== "") {
      const email = localStorage.getItem('email')
      window.analytics.track('New Signup Meal prep Settings', {
        'id':email,
        'Default Servings': trackAnalytics.default_serving_size || 2,
        'Preferred Prep Day': trackAnalytics.meal_prep_day,
        'Recipe Preference': trackAnalytics.recipes_with_meat,
      });
      window.heap.addUserProperties({
        'id':email,
        'Standard Servings': trackAnalytics.default_serving_size || 2,
        'Preferred Prep Day': trackAnalytics.meal_prep_day,
        'Recipe Preference': trackAnalytics.recipes_with_meat,
      })
      this.props.onClickNext(params, url);
    } else {
      if (!default_serving_size) {
        errorMessage.default_serving_size = 'Please Select people cooking for value from dropdown';
      } else {
        errorMessage.default_serving_size = false;
      }
      if (!meal_prep_day) {
        errorMessage.meal_prep_day = 'Please Select your cooking day';
      } else {   
        errorMessage.meal_prep_day = false;
      }
      if (!recipes_with_meat) {
        errorMessage.recipes_with_meat = 'Please Select your recipes choice';
      } else {   
        errorMessage.recipes_with_meat = false;
      }
      this.setState({ errorMessage, loadData: false });
    }
  }

  updateList(itemKey, itemVal){
    const { DIET_TYPE } = this.state
    const index = DIET_TYPE.indexOf(itemVal)
    if(index === -1) {
      DIET_TYPE.push(itemVal)
    } else {
      DIET_TYPE.splice(index,1)
    }
    this.setState({DIET_TYPE});
  }

  async loadData() {

    const data = await sessionStorage.getItem('guestAccount') ?
      JSON.parse(sessionStorage.getItem('guestAccount')) : null;
    if (data && data.mealPlan) {
      this.setState(data.mealPlan);
    }
  }

  updateValue(event, trackValue) {
    const { params, errorMessage, trackAnalytics } = this.state
    params[event.target.name] = event.target.value
    trackAnalytics[event.target.name] = trackValue
    errorMessage[event.target.name] = false
    console.log(trackValue)
    this.setState({ params, errorMessage, trackAnalytics})

  }

  render() {
    const { errorMessage, loadData } = this.state;
    const { default_serving_size, meal_prep_day } = this.state.params
    return (
      <section className="main-cntnt slidetest" style={{right: '-300px'}}>
        <div className="container" style={{ marginBottom: '80px' }}>
          <div className="main-cntnt-box">
            {
              loadData &&
              <div className="loading">
                <Loader />
                <div className="modal-backdrop fade in" />
              </div>
            }
            <h2 className="mb-hide">Just a couple more details!</h2>
            {/* <h2 className="mb-only">Great! Nice to meet you {userName}!</h2> */}
            <p className="hdng-para">We just need to know a couple things to get you started.</p>
            <div className="main-cntnt-inner">
              <div className="col-xs-12 col-md-4 intro-sectn">
                <div className="timeline">
                  <div className='timeline-row'>
                    <div className="timeline-content">
                      <span />
                      <p>Your Account</p>
                    </div>
                  </div>
                  <div className='timeline-row'>
                    <div className="timeline-content">
                      <span />
                      <p>The Basics</p>
                    </div>
                  </div>
                  <div className='timeline-row active'>
                    <div className="timeline-content">
                      <span />
                      <p>Meal Prep Style</p>
                    </div>
                  </div>
                  <div className='timeline-row last-row-timeline'>
                    <div className="timeline-content">
                      <span />
                      <p>Build Your First Plan</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-8 login-sectn">
                <div>
                  <div className="row">
                    <h4 className="mb-only text-left new-step-mb">Step 3: Meal Prep Preferences</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12 form-row select-row-small mealplan-top-row">
                      <label  htmlFor="cooking_for" className={errorMessage.default_serving_size ? 'container1 error-label' : 'container1'}>
                          How many people do you meal plan for on a weekly basis?
                      </label>
                      <div className="btn-group bootstrap-select custm-selct mealplan-btn">

                        <select className="selectpicker show-tick form-control data-hj-whitelist" name="default_serving_size" onChange={(e) => { this.updateValue(e, e.target.value) }} value={default_serving_size}>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-12 form-row select-row-small mealplan-top-row">
                      <label  htmlFor="meal_prep_day" className={errorMessage.meal_prep_day ? 'container1 error-label' : 'container1'}>
                          What day do of the week do you typically want to meal prep on?
                      </label>
                      <div className="btn-group bootstrap-select custm-selct mealplan-btn meal-day">

                        <select className="selectpicker show-tick form-control data-hj-whitelist" name="meal_prep_day" onChange={(e) => { this.updateValue(e, e.target.value) }} value={meal_prep_day}>
                          <option value="">Select a day</option>
                          <option value="Sun">Sun</option>
                          <option value="Mon">Mon</option>
                          <option value="Tue">Tue</option>
                          <option value="Wed">Wed</option>
                          <option value="Thu">Thu</option>
                          <option value="Fri">Fri</option>
                          <option value="Sat">Sat</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-12 form-row">
                      <p
                        className={errorMessage.recipes_with_meat ?
                          'inner-check-row-hdng error-label' : 'nner-check-row-hdng'}
                      >
                        Do you want to to see recipes with meat or fish?
                      </p>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" name="recipes_with_meat" value="no" onChange={(event) => { this.updateValue(event, 'no') }} data-hj-whitelist/>
                          <span className="checkmark" /><b>Yes - </b> I'd like to eat recipes with meat in them
                        </label>
                      </div>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" name="recipes_with_meat" value='yes' onChange={(event) => { this.updateValue(event, 'yes')}} data-hj-whitelist/>
                          <span className="checkmark" /><b>No - </b> I'm a vegan/vegetarian
                        </label>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="form-row text-right cnfrm-btn-box col-md-12">
                      <button className="next-btn" onClick={() => this.onClickNext()}>Confirm</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/register/MealPlan.js